export class Dde {
    direccion: string;
    urbanizacion: string;
    provincia: string;
    departamento: string;
    codigoPais: string;
    tipoDocId: string;
    numeroDocId: string;
    razonSocial: string;

    constructor(direccion?: string,
                urbanizacion?: string,
                provincia?: string,
                departamento?: string,
                codigoPais: string = 'PE',
                tipoDocId?: string,
                numeroDocId?: string,
                razonSocial?: string
    ) {
        this.direccion = direccion;
        this.urbanizacion = urbanizacion;
        this.provincia = provincia;
        this.departamento = departamento;
        this.codigoPais = codigoPais;
        this.tipoDocId = tipoDocId;
        this.numeroDocId = numeroDocId;
        this.razonSocial = razonSocial;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/dde.ts